export default "__VITE_ASSET__8e962c43__"